import CheckBox from '@uikit/components/CheckBox/CheckBox';
import clsx from 'clsx';
import type { MultiSelectItemProps } from './interfaces';
import styles from './MultiSelectItem.module.scss';

const MultiSelectItem = ({
  item,
  isActive,
  isFocus,
  onClick,
  listBoxId,
  indented,
}: MultiSelectItemProps) => {
  return (
    <li
      className={clsx(styles.item, {
        [styles.active]: isActive,
        [styles.focus]: isFocus,
        [styles.indented]: indented,
      })}
      onClick={onClick}
      id={listBoxId}
      role="option"
      aria-selected={isActive}
    >
      <CheckBox tabIndex={-1} checked={isActive} readOnly />
      <span className={styles.text}>
        {item.label} {item.count?.toString() ? `(${item.count})` : ''}
      </span>
    </li>
  );
};

export default MultiSelectItem;
